import { t } from 'i18next';
import { lazy } from 'react';

import { Image } from '@app/shared/ui/atoms/Common';
import { marketPack1, marketPack2, marketPack3, marketPack4, marketPack5 } from '@app/assets';
const CoverflowCarousel = lazy(() => import('@app/shared/ui/atoms/Common/CoverflowCarousel'));

const packs = [
  { image: marketPack1, title: 'starter', price: '7' },
  { image: marketPack2, title: 'basic', price: '31' },
  { image: marketPack3, title: 'pro', price: '111' },
  { image: marketPack4, title: 'elite', price: '271' },
  { image: marketPack5, title: 'legend', price: '591' },
];

interface PackCarouselProps {
  onPackClick: (value: string) => void;
}

export const PackCarousel = ({ onPackClick }: PackCarouselProps) => {
  return (
    <div className="w-full h-full">
      <CoverflowCarousel slidesPerView={3} spaceBetween={50}>
        {(SwiperSlide) =>
          packs.map((pack, i) => (
            <SwiperSlide key={i} className="">
              <div
                className="h-[280px] w-[200px] flex flex-col justify-center items-center gap-2"
                onClick={() => {
                  onPackClick(pack.price);
                }}
              >
                <Image src={pack.image} className="max-h-full w-auto object-contain" />
                <span className="bg-blue-dark shadow-blue w-fit px-2 py-1 rounded-xl text-sm">
                  {t(`packs.${pack.title}`)}
                </span>
              </div>
            </SwiperSlide>
          ))
        }
      </CoverflowCarousel>
    </div>
  );
};
